import styled from '@emotion/styled'
import * as React from 'react'

import { minWidth } from '@emico/styles'

import Form from './AccountAccessForm'
import AccountUsps from './AccountUsps'
import Container from './layout/Container'

const StyledContainer = styled.div`
    position: relative;
`

const Wrapper = styled.div`
    display: flex;
    flex-flow: column nowrap;
    padding-top: 60px;
    padding-bottom: 100px;
    gap: 50px;

    @media ${minWidth('lg')} {
        position: relative;
        padding-top: 100px;
        flex-flow: row nowrap;
        justify-content: center;
        max-width: 880px;
        margin: 0 auto;
        min-height: 80vh;
        gap: 0;
    }
`

const FormWrapper = styled.div`
    margin: 0;

    @media ${minWidth('lg')} {
        padding: 0 3em 0 0;
        flex: 1;
    }
`

export const AccountAccessLayout = ({
    // eslint-disable-next-line react/prop-types
    type,
}: React.ComponentProps<typeof Form>) => (
    <Container>
        <StyledContainer>
            <Wrapper>
                <FormWrapper>
                    <Form type={type} />
                </FormWrapper>
                <AccountUsps />
            </Wrapper>
        </StyledContainer>
    </Container>
)

export default AccountAccessLayout
